import Footer from "./components/Footer";
// import Navbar from "./components/Navbar";
import {
  AboutAuthor,
  BuyBook,
  BookChapters,
  Home,
  Productivity,
  TrustedStores,
  Testimonials,
} from "./pages";

const App = () => {
  return (
    <div>
      {/* <Navbar /> */}
      <Home />
      <TrustedStores />
      <AboutAuthor />
      <BookChapters />
      <Testimonials />
      <Productivity />
      <BuyBook />
      <Footer />
    </div>
  );
};

export default App;
